// src/features/analytics/analyticsApi.ts
import { api } from '@/store/api'

export interface CourseReview {
  id: number
  createdAt: string
  text: string
  rating: number
  user: {
    id: number
    username: string | null
    avatar: string | null
    colour: string | null
    telegramUsername: string | null
  }
}

interface ReviewsPage {
  items: CourseReview[]
  page: number
  pages: number
  total: number
}

/** Размер страницы отзывов: столько подгружается за один раз. */
export const REVIEWS_PAGE_SIZE = 10

// Запрос списка отзывов — тот же, что у веб-академии (`gamified-courses/{id}/reviews`).
// Сводной аналитики автора (динамика по дням, прогресс учеников) у бэка нет.
export const analyticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCourseReviews: build.infiniteQuery<ReviewsPage, number, number>({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (last) => (last.page < last.pages ? last.page + 1 : undefined),
      },
      query: ({ queryArg: courseId, pageParam }) => ({
        url: `gamified-courses/${courseId}/reviews`,
        params: { page: pageParam, limit: REVIEWS_PAGE_SIZE },
      }),
    }),
  }),
})

export const { useGetCourseReviewsInfiniteQuery } = analyticsApi
